import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { listPossibleWorkSites } from '../../redux/actions/table/timesheets';
import styles from '../../styles/forms/timesheets/EditTimeEntryForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { __, setFormValue } from '../../core/utils';
import Select from '../../components/Select';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import Checkbox from '../../components/Checkbox';
import DateTimePicker from '../../components/DateTimePicker';
import { listPossibleSubstagesWithChildrenByStage } from '../../redux/actions/table/all_tasks';
import {
  listPossibleSpecificationProjects,
  listPossibleSpecificationStages,
} from '../../redux/actions/table/working_set_specifications';
import { enableAutosave } from '../../redux/actions/general/autosave';
import { createAddressBookCompany } from '../../redux/actions/table/address_book_companies';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import SearchableDropdown from '../../components/SearchableDropdown';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import classNames from 'classnames';
import Tooltip from '../../components/Tooltip';

@reduxForm({
  form: 'timesheets.edit_timeentry',
  enableReinitialize: true,
})
@withRouter
@subscribe(Localization, 'localization')
class EditTimeEntryForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_projects: [],
      possible_stages: [],
      possible_substages_with_children: [],
      possible_work_sites: [],
      selected_substage_task: {
        values: [],
        label: null,
        type: null,
      },
    };
  }

  _normalizeDropdownOptions = (options = []) =>
    _.map(options, (option, index) => ({
      ...option,
      group_option_key:
        option?.group_option_key || `__group__${option?.group_id}`,
      option_key:
        option?.option_key ||
        ['be', option?.group_id, option?.value, option?.label, index].join('_'),
    }));

  _getSelectedSubstageTaskState = (options = [], taskId, substageId) => {
    const normalizedOptions = this._normalizeDropdownOptions(options);

    if (!_.isNil(taskId)) {
      const selectedTask = _.find(normalizedOptions, ['value', taskId]);

      if (selectedTask) {
        return {
          values: [selectedTask.option_key],
          label: selectedTask.label || null,
          type: 'child',
        };
      }
    }

    if (!_.isNil(substageId)) {
      const selectedGroup = _.find(normalizedOptions, ['group_id', substageId]);

      if (selectedGroup) {
        const groupValues = _.map(
          _.filter(normalizedOptions, ['group_id', substageId]),
          'option_key',
        );

        return {
          values: [selectedGroup.group_option_key, ...groupValues],
          label: selectedGroup.group || null,
          type: 'group',
        };
      }
    }

    return {
      values: [],
      label: null,
      type: null,
    };
  };

  _submitDropdownSelection = () => {
    setTimeout(() => {
      if (this.props.submit) {
        this.props.submit();
      }
    }, 10);
  };

  componentDidMount() {
    const active_project = this.props.initialValues?.project_id;
    const active_stage = this.props.initialValues?.stage_id;

    listPossibleSpecificationProjects().then(({ response }) => {
      this.setState({ possible_projects: response.data });
    });

    if (active_project) {
      listPossibleSpecificationStages(active_project).then(({ response }) => {
        this.setState({ possible_stages: response.data });
      });
    }

    if (active_stage) {
      listPossibleSubstagesWithChildrenByStage(active_stage).then(
        ({ response }) => {
          const options = response.data || [];

          this.setState({
            possible_substages_with_children: options,
            selected_substage_task: this._getSelectedSubstageTaskState(
              options,
              this.props.initialValues?.task_id,
              this.props.initialValues?.substage_id,
            ),
          });
        },
      );
    }

    listPossibleWorkSites().then(({ response }) => {
      this.setState({ possible_work_sites: response.data });
    });
  }

  UNSAFE_componentWillReceiveProps(prevProps) {
    setTimeout(() => enableAutosave(this.props.form), 1500);
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.data != this.props.data) {
  //     const active_project = this.props.initialValues.project_id;
  //     const active_stage = this.props.initialValues.stage_id;

  //     listPossibleSpecificationProjects().then(({ response }) => {
  //       this.setState({ possible_projects: response.data });
  //     });

  //     if (active_project) {
  //       listPossibleSpecificationStages(active_project).then(({ response }) => {
  //         this.setState({ possible_stages: response.data });
  //       });
  //     }

  //     if (active_stage) {
  //       listPossibleMeetingTasks(active_stage).then(({ response }) => {
  //         this.setState({ possible_meeting_tasks: response.data });
  //       });
  //     }

  //     listPossibleWorkSites().then(({ response }) => {
  //       this.setState({ possible_work_sites: response.data });
  //     });
  //   }
  // }

  componentDidUpdate(prevProps) {
    // 1. Kad dođu novi podaci iz BE (npr. otvaranje edita)
    if (prevProps.data !== this.props.data) {
      const active_project = this.props.initialValues.project_id;
      const active_stage = this.props.initialValues.stage_id;

      listPossibleSpecificationProjects().then(({ response }) => {
        this.setState({ possible_projects: response.data });
      });

      if (active_project) {
        listPossibleSpecificationStages(active_project).then(({ response }) => {
          this.setState({ possible_stages: response.data });
        });
      }

      if (active_stage) {
        listPossibleSubstagesWithChildrenByStage(active_stage).then(
          ({ response }) => {
            const options = response.data || [];

            this.setState({
              possible_substages_with_children: options,
              selected_substage_task: this._getSelectedSubstageTaskState(
                options,
                this.props.initialValues?.task_id,
                this.props.initialValues?.substage_id,
              ),
            });
          },
        );
      }

      listPossibleWorkSites().then(({ response }) => {
        this.setState({ possible_work_sites: response.data });
      });
    }

    // 2. Kad korisnik promijeni PROJECT u formi
    const prevProject = prevProps.formValues?.project_id;
    const newProject = this.props.formValues?.project_id;

    if (prevProject !== newProject && this.props.anyTouched) {
      if (newProject) {
        this.props.change('stage_id', null);
        this.props.change('task_id', null);

        listPossibleSpecificationStages(newProject).then(({ response }) => {
          this.setState({
            possible_stages: response.data,
            possible_substages_with_children: [],
            selected_substage_task: { values: [], label: null, type: null },
          });
        });
      } else {
        this.setState({
          possible_stages: [],
          possible_substages_with_children: [],
          selected_substage_task: { values: [], label: null, type: null },
        });

        this.props.change('stage_id', null);
        this.props.change('task_id', null);
        this.props.change('substage_id', null);
      }
    }

    // 3. Kad korisnik promijeni STAGE u formi
    const prevStage = prevProps.formValues?.stage_id;
    const newStage = this.props.formValues?.stage_id;

    if (prevStage !== newStage && this.props.anyTouched) {
      if (newStage) {
        this.props.change('task_id', null);
        this.props.change('substage_id', null);

        listPossibleSubstagesWithChildrenByStage(newStage).then(
          ({ response }) => {
            this.setState({
              possible_substages_with_children: response.data || [],
              selected_substage_task: { values: [], label: null, type: null },
            });
          },
        );
      } else {
        this.setState({
          possible_substages_with_children: [],
          selected_substage_task: { values: [], label: null, type: null },
        });
        this.props.change('task_id', null);
        this.props.change('substage_id', null);
      }
    }
  }

  render() {
    const possibleMinutes = [
      { value: '0', label: '00' },
      { value: 15, label: '15' },
      { value: 30, label: '30' },
      { value: 45, label: '45' },
    ];

    const {
      possible_projects,
      possible_stages,
      possible_substages_with_children,
      possible_work_sites,
      selected_substage_task,
    } = this.state;

    const dropdownOptions = this._normalizeDropdownOptions(
      possible_substages_with_children,
    );

    const createNewWorksite = (value) => {
      createAddressBookCompany({ name: value, is_office: 1 }).then(
        ({ response }) => {
          listPossibleWorkSites()
            .then(({ response }) => {
              this.setState({ possible_work_sites: response.data });
            })
            .then(() => {
              this.props.change(
                'address_book_company_id',
                _.get(response.data, 'id'),
              );
              setTimeout(() => {
                if (this.props.submit) {
                  this.props.submit();
                }
              }, 0);
            });
        },
      );
    };

    return (
      <Form className={styles.wrapper}>
        <div className={styles.section}>
          <div className={styles.flex}></div>
          <div className={styles.flex}>
            <div className={styles.f2}>
              <Field
                name='date'
                component={DateTimePicker}
                label={__('table.columns.timesheet-date')}
                footer
              />
            </div>
            <div className={styles.f4} />
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='hours'
                component={Input}
                label={__('table.columns.timesheet-hours')}
                numeric
                maxLength={4}
                hint={__('timesheets.hint.in-hours')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                name='minutes'
                component={Select}
                searchable
                options={possibleMinutes}
                label={__('table.columns.timesheet-minutes')}
              />
            </div>
            <div className={styles.f2} />
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='project_id'
                searchable={true}
                component={Select}
                onBlur={() => {
                  return null;
                }}
                onChange={() => {
                  return null;
                }}
                label={__('edit-timesheet-form.project')}
                options={_.map(possible_projects, (project) => ({
                  value: project.id,
                  label: [project.code, project.name].join(': '),
                }))}
                placeholder={__('edit-time-entry-form.select-project')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                name='stage_id'
                searchable={true}
                component={Select}
                label={__('edit-timesheet-form.stage')}
                options={_.map(possible_stages, (stage) => ({
                  value: stage.id,
                  label: [_.padStart(stage.order, 2, '0'), stage.name].join(
                    ': ',
                  ),
                }))}
                placeholder={__('edit-time-entry-form.select-stage')}
              />
            </div>
          </div>
          {/* <Field
            name='task_id'
            searchable={true}
            component={Select}
            label={__('edit-timesheet-form.task')}
            options={_.map(possible_meeting_tasks, (task) => ({
              value: task.id,
              label: ['T-', task.identifier, ': ', task.title],
            }))}
            placeholder={__('edit-time-entry-form.select-task')}
          /> */}
          <div className={styles.searchableDropdownWrapper}>
            <SearchableDropdown
              options={dropdownOptions}
              dropdownWrapperClassName={styles.dropdownWrapper}
              multiselect
              closable={false}
              name='timeentry_substage_task_selector'
              leftStyled
              selectedValues={selected_substage_task.values}
              header={
                <div className={styles.dropdownHeader}>
                  <Tooltip
                    text={__('edit-timesheet-form.task')}
                    className={styles.filterHeaderName}
                  >
                    {__('edit-timesheet-form.task')}
                  </Tooltip>

                  <span
                    className={styles.filterHeaderClearAll}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({
                        selected_substage_task: {
                          values: [],
                          label: null,
                          type: null,
                        },
                      });
                      this.props.change('task_id', null);
                      this.props.change('substage_id', null);
                    }}
                  >
                    {__('add-timesheet-form.substages-and-tasks.clear')}
                  </span>
                </div>
              }
              onButtonClick={this._submitDropdownSelection}
              onSelect={(item, groupLabel) => {
                if (item.groupHeading) {
                  const groupValues = _.map(
                    _.filter(dropdownOptions, (option) =>
                      item.group_id
                        ? option.group_id === item.group_id
                        : option.group === groupLabel,
                    ),
                    'option_key',
                  );

                  this.setState({
                    selected_substage_task: {
                      values: [item.group_option_key, ...groupValues],
                      label: groupLabel || null,
                      type: 'group',
                    },
                  });
                  this.props.change('task_id', null);
                  this.props.change('substage_id', item.group_id || null);
                  return;
                }

                this.setState({
                  selected_substage_task: {
                    values: [item.option_key || item.value],
                    label: item.label || null,
                    type: 'child',
                  },
                });
                this.props.change('task_id', item.value || null);
                this.props.change('substage_id', null);
              }}
              onRemove={() => {
                this.setState({
                  selected_substage_task: {
                    values: [],
                    label: null,
                    type: null,
                  },
                });
                this.props.change('task_id', null);
                this.props.change('substage_id', null);
              }}
            >
              <div className={classNames(styles.bubble)}>
                <label className={styles.bubbleLabel}>
                  {__('edit-timesheet-form.task')}
                </label>
                <span
                  className={classNames(
                    !selected_substage_task.label && styles.bubblePlaceholder,
                  )}
                >
                  {(this.props.formValues?.substage_name
                    ? `${this.props.formValues.substage_name} / `
                    : '') +
                    (selected_substage_task?.label ||
                      __('add-timesheet-form.choose-substage-or-task'))}
                </span>
                <ArrowDownSmallIcon className={styles.bubbleArrow} />
              </div>
            </SearchableDropdown>
          </div>
          <Field name='task_id' component='input' type='hidden' />
          <Field name='substage_id' component='input' type='hidden' />
          <Field
            name='address_book_company_id'
            searchable={true}
            component={Select}
            label={__('edit-timesheet-form.work-site')}
            options={_.map(possible_work_sites, (workSite) => ({
              value: workSite.id,
              label: workSite.name,
            }))}
            callbackSetNewValue={(value) => {
              createNewWorksite(value);
            }}
            placeholder={__('edit-time-entry-form.select-location')}
          />
          <Field
            name='description'
            component={Textarea}
            label={__('edit-timesheet-form.description')}
            maxLength={200}
            rows={1}
            maxRows={5}
            placeholder={__('edit-time-entry-form.add-description')}
          />
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='is_billable'
                component={Checkbox}
                label={__('edit-timesheet-form.nonbillable')}
                className={styles.checkbox}
                onChange={(event) => {}}
              />
            </div>
            <div className={styles.f5}>
              <Field
                name='is_makeup_time'
                component={Checkbox}
                label={__('edit-timesheet-form.not_overtime')}
                className={styles.checkbox}
              />
            </div>
          </div>
        </div>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  formValues: getFormValues('timesheets.edit_timeentry')(state),
});

export default connect(mapStateToProps)(EditTimeEntryForm);

// export default EditTimeEntryForm;
